module.exports = "<div class=\"gauge-container basicarea\"></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/charts/basicarea.html
// module id = 627
// module chunks = 0